// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"349":"3339126957748904","1353":"ad0a98de0fe9f3c8"}[chunkId] + ".js";
};